var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin mx-3"},[_c('h2',{staticClass:"is-size-3 has-text-left ml-5"},[_vm._v("Doktorlar")]),_c('b-table',{attrs:{"data":_vm.doctors.data,"columns":_vm.columns}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }